import { Component, OnInit, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-rpt-inv-mtl-availability',
  templateUrl: './rpt-inv-mtl-availability.component.html',
  styleUrls: ['./rpt-inv-mtl-availability.component.scss']
})
export class RptInvMtlAvailabilityComponent implements OnInit {

  //Table sort and column
  displayedColumns: string[] = ['Material', 'PerUnitQty', 'TotalNeededQty', 'StockQty', 'ShortFallQty', 'Unit'];
  dataSource = new MatTableDataSource();

  @ViewChild('mtlAviaTable', { static: false }) mtlAviaTable!: ElementRef;
  // SpinnerService: any;

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
  }

  //Variable Declaration
  agencyData: any = [];
  jarvisData: any = [];
  materialAvailabilityList: any = [];
  exportToExcel: any = [];
  unitList:any = [];
  productListData:any = [];

  productList: any = {
    prodID: "0",
    name: '',
    unitName: '',
    unitID: "0",
    qty: "",
    prcn: "0"
  }

  unit = {
    uID: "0",
    uNm: ""
  };

  Items:any = '[]';
  statusID: number = 1;
  mtlHasTags: boolean = false;
  showItemsTags: boolean = false;

  constructor(private apiService: APIService, public CmnService: CommonService, private router: Router, private SpinnerService: NgxSpinnerService) { }

  ngOnInit(): void {

    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
      //Get Unit List
      let unitData = this.apiService.getCookie("ERP_Cfg");
      if (unitData) {
        this.unitList = JSON.parse(unitData)
        this.unitList = this.unitList[0].Units;
        this.unitList = JSON.parse(this.unitList);
      }

      
      this.apiService.getIDB('erp_inv', (tempItems: any) => {
        if (tempItems && tempItems.length > 0) {
          this.productListData = tempItems;
          this.productListData = $.grep(this.productListData, function(o: any){ return o.TypeID == 1 || o.TypeID == 4});
          this.productListData = this.productListData.filter((item: any)=> item.IsActive ? item.IsActive : 0);
        } else {
          let billables = [];
          let cfgAgnCookie = this.apiService.getCookie('Cfg_AgnCfg');
          if (cfgAgnCookie) {
              let cfgAgnData = JSON.parse(cfgAgnCookie);
              if (cfgAgnData.length > 0) {
                  let blbJSON = cfgAgnData[0]?.Billables ? cfgAgnData[0].Billables : '[]';
                  billables = JSON.parse(blbJSON);
              }
          }
          this.productListData = billables
              .filter((b: any) => b?.IID && b.IID > 0 && b.INm && b.IsA && (b.TID == 1 || b.TID == 4))
              .map((item: any) => {return {
                ItemID: item.IID,
                ItemName: item.INm,
                ItemCode: item?.ICd ? item?.ICd : '',
                DefSaleRate: item.SRT ? item.SRT : 0,
                TypeID: item.TID,
                SKU: item.Unit,
          }})
          // this.getProdData();
        }
      });
  }

  //Get Data - Call API
  getData() {
    if (this.productList.prodID == 0) {
        alert ("Please select a product to check availability.")
        return;
    }
    
    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
     let data = [
        {
          ProductID: this.productList.prodID,
          MakeQty: this.productList.qty
        }
      ];
    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getMaterialAvailability',
        moduleID: 12,
        data: JSON.stringify(data),
      },
    ];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this)
    );
  }

  //Success Response - Success handler
  successResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode != '-1') {
          alert(reponseData.Table[0].ErrMsg);
        } else {
          if (reponseData.Table[0].ErrCode == -1) {
            this.showItemsTags = false;
            this.mtlHasTags = false;
            this.materialAvailabilityList = reponseData.Table2;

            let hasTags = $.grep(this.materialAvailabilityList, function(o: any){ return o.Tags && o.Tags != ''});
            if (hasTags.length > 0) {
              this.showItemsTags = true;
              this.mtlHasTags = true;
            }
            this.toggleItemsTags();

            this.materialAvailabilityList = this.materialAvailabilityList.map((item: any) => {
              return {
                ...item,
                Tags: item.Tags.replace(/,/g, ', ').replace(/, $/, '')
              };
            });

            this.dataSource.data = this.materialAvailabilityList;
            this.exportToExcel = this.materialAvailabilityList;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.matSort;
          }
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

  //search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getProdData() {



    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [{
      StatusID: this.statusID,
      StoreID: 0
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successRespItem.bind(this), this.failureRespItem.bind(this));
  }

  //successResp - success  get handler
  successRespItem(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let data = reponseData;
          let tempItems = data.Table1;
          this.productList = tempItems
          this.apiService.setIDB('erp_inv', this.productList);
          this.productList = tempItems.filter((x: any)=> x.IsActive ? x.IsActive : 0);
        }
      }
    }
  }

  //failureResp - failure handler
  failureRespItem(res: any) {
   
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  ChangeProduct(){
    if(this.productListData){
      let selectProduct = this.productListData.filter((x: any) => x.ItemID == this.productList.prodID);
      if(selectProduct.length > 0){
        this.productList.prodID = String(selectProduct[0].ItemID);
        this.productList.name = selectProduct[0].ItemName;
        this.productList.unitName = selectProduct[0].SKU;
        if(this.productList.unitName){
          let selectUnit = this.unitList.filter((x: any) => x.UNm == this.productList.unitName);
          if(selectUnit.length > 0){
            this.productList.unitID = selectUnit[0].UID;
            this.changeUnit();
          }
          
        }
      }
      else{
        this.productList.unitID = "0";
        this.productList.unitName = "";
        this.changeUnit();
      }
    }
  }

  changeUnit(){
    let selectUnit = this.unitList.filter((x: any) => x.UID == this.productList.unitID);
    if(selectUnit.length > 0){
      this.productList.unitName = selectUnit[0].UNm;
      this.productList.unitID = selectUnit[0].UID;
      this.productList.prcn = selectUnit[0].Prcsn;
    }
    else{
      this.productList.prodID = "0";
      this.productList.unitID = "0";
      this.productList.unitName = "";
    }
  }

    //Export To Excel
    exportToExcelActivities() {
      var html = "";
      // Title
      html += "<table><tr>";
      html += "<th style='text-align: left;'>Material Availability</th>"
      html += "</table></tr>";
  
      html += "<table><tr></table></tr>";
      html += "<table><tr>";
  
      //Hader Title
      if(this.productList.prodID != 0)
      {
      html += "<p><b> Product : </b>" + this.productList.name + "</p>"
      }
      if(this.productList.qty != 0)
      {
        html += "<p><b> Qty : </b>" + this.productList.qty + "</p>"
      }
      if(this.productList.unitID != 0)
      {
        html += "<p><b> Unit : </b>" + this.productList.unitName + "</p>"
      }

      // Blank Column
      html += "<table><tr>";
  
      var strHeader = ""
      strHeader += "<th style='text-align: left;'>Material</th>";
      strHeader += "<th style='text-align: left;'>Per Unit</th>";
      strHeader += "<th style='text-align: left;'>Total Need</th>";
      strHeader += "<th style='text-align: left;'>Stock</th>";
      strHeader += "<th style='text-align: left;'>Shortfall</th>";
      strHeader += "<th style='text-align: left;'>Unit</th>";
      if (this.showItemsTags) {
        strHeader += "<th style='text-align: left;'>Tags</th>";
      }
      strHeader += "</tr>"
      html += strHeader;
      var body = "";
  
      this.exportToExcel.forEach((item: any, key: any) => {
        body += "<tr>";
        body += "<td style='text-align: left;'>" + item.Material + "</td>";
        body += "<td style='text-align: left;'>" + item.PerUnitQty + "</td>";
        body += "<td style='text-align: left;'>" + (item.TotalNeededQty ? item.TotalNeededQty : '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.StockQty ? item.StockQty : '-') + "</td>";
        body += "<td style='text-align: left;'>" + (item.ShortFallQty ? item.ShortFallQty : '-') + "</td>";
        body += "<td style='text-align: left;'>" + item.Unit + "</td>";
        if (this.showItemsTags) {
          body += "<td style='text-align: left;'>" + (item.Tags ? item.Tags : '') + "</td>";
        }
        body += "</tr>";
      })
      
      html += body;
      html += "</table>";
      this.tableToExcel(html, 'Sheet1', 'Material Availability');
    }
  
      //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      //window.location.href = uri + base64(format(template, ctx))
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  backBtn() {
    this.router.navigate(['/Stock']);
  }
  // backBtn() {
  //   this.router.navigate(['/ProductionList']);
  // }

  prcnQty() {
    this.productList.qty = Number(this.productList.qty).toFixed(this.productList.prcn);
  }

 //qty with prcn
  enterQty = () => {
    this.productList.qty  = this.CmnService.PrecisionwiseValue(this.productList.qty, this.productList.prcn);
  }

  toggleItemsTags = () => {
    if (this.showItemsTags) {
      this.displayedColumns = ['Material', 'PerUnitQty', 'TotalNeededQty', 'StockQty', 'ShortFallQty', 'Unit', 'Tags'];
    }
    else {
      this.displayedColumns = ['Material', 'PerUnitQty', 'TotalNeededQty', 'StockQty', 'ShortFallQty', 'Unit'];
    }
  }

}
